import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import it from "./locales/it.json";
import nl from "./locales/nl.json";
import ro from "./locales/ro.json";

// Los codigos coinciden con la tabla `locales` de la BD: el idioma elegido aqui
// es el que se manda como ?lang= al pedir el contenido de las actividades.
// El orden es el del diseno del modal, no el alfabetico.
//
// Los nombres son endonimos y NO se traducen: quien busca su idioma reconoce
// "Romana" aunque la interfaz este en ingles, que es justo cuando lo necesita.
// Por eso viven aqui y no en los ficheros de locale, donde serian cuatro copias
// identicas. Coinciden con locales.name de la BD.
export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "it", name: "Italiano" },
  { code: "ro", name: "Română" },
  { code: "nl", name: "Nederlands" },
];

const STORAGE_KEY = "vippstar_lang";

// El idioma guardado se valida contra la lista: si alguien toca el
// localStorage a mano, se cae a ingles en vez de dejar la interfaz sin textos.
const storedLanguage = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED_LANGUAGES.some((lang) => lang.code === saved) ? saved : "en";
  } catch {
    return "en";
  }
};

export const changeLanguage = (code) => {
  i18n.changeLanguage(code);
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Modo privado o almacenamiento bloqueado: el idioma dura la sesion.
  }
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    it: { translation: it },
    nl: { translation: nl },
    ro: { translation: ro },
  },
  lng: storedLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
